// Cuberto Mouse Follower
import MouseFollower from 'mouse-follower';
import gsap from 'gsap';

if (window.matchMedia('(pointer:fine)').matches) {
  MouseFollower.registerGSAP(gsap);

  const cursor = new MouseFollower({
    className: 'zidney-cursor',
    innerClassName: 'zidney-cursor-inner',
    textClassName: 'zidney-cursor-text',
    mediaClassName: 'zidney-cursor-media',
    mediaBoxClassName: 'zidney-cursor-media-box',
    iconSvgClassName: 'zidney-svgsprite',
    iconSvgSrc: '/assets/sprites/svgsprites.svg',
    skewing: 3.5,
    skewingMedia: 0.5,
    stateDetection: {
      '-pointer': `
                .btn, [type="button"],
                .nav-link,
                a.dropdown-item,
                footer .footer-links li a:not([data-cursor-text]),
                .stretched-link,
                [class*='link-']`,
      '-magnify -color-burn': `
                [data-cursor-magnify],
                [data-cursor-magnify-inner] > *,
                .navbar-brand`,
    },
  });

  // Fix for element with higher z-index
  cursor.on('show', () => {
    document.body.classList.add('zidney-cursor-show');
  });
}
